<template>
    <el-card>
        <app-breadcrumb :items="items"></app-breadcrumb>
    </el-card>
</template>

<script>
    export default {
        
    }
</script>


// WEBPACK FOOTER //
// src/components/auditoria/notificactionUsers.vue